import React, {useState, useEffect, useContext, Fragment} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import 'react-times/css/classic/default.css';
import {Link} from 'react-router-dom';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from "../../../assets/images/imageData";
import {Button} from "react-bootstrap";
import ListFilters from 'components/sales/ListFilters/ListFilters';

const EnggTasksDetails = ({
                              getList,
                              taskList
                          }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [pageCount, setPageCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [role, setRole] = useState('')
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);

    useEffect(() => {
        (async () => {
            let roles = JSON.parse(localStorage.getItem('roles'))
            setRole(roles[0]?.id)
            setIsLoading(true)
            await getList()
            setIsLoading(false)
        })()
    }, [])


    const headers = [
        'Engineer Name',
        'Client Name',
        // 'City Name',
        'Latitude',
        'Longitude',
        'Task Date',
        'Task Type',
        'Requested By',
        'Document',
        'Distance',
    ];

    useEffect(() => {
        if (taskList && taskList?.data && taskList?.data !== []) {
            let tableHeaders = ['id', 'name', 'client_name', 'lat', 'long', 'task_date', 'task_type', 'requested_by' , 'document', 'distance_in_km'];
            const data = taskList?.data.map((element) =>
                Object.assign(
                    {},
                    ...tableHeaders.map((key) => (
                        key === 'document' && (element['documents'].split('.').pop() === 'jpeg' || element['documents'].split('.').pop() === 'jpg' || element['documents'].split('.').pop() === 'png') ?
                            {
                                [key]: <a href={element['documents']} target="_blank"><img src={element['documents']}
                                                                                           style={{
                                                                                               "width": "48px",
                                                                                               "borderRadius": "16px",
                                                                                               "height": "48px"
                                                                                           }}/></a>
                            } :
                            key === 'document' && element['documents'].split('.').pop() === 'doc' ? {
                                    [key]: <a href={element['documents']} target="_blank"><img src={Images?.DocIcon}
                                                                                               alt=""
                                                                                               className="view-icon"/></a>
                                } :
                                key === 'document' && element['documents'].split('.').pop() === 'pdf' ? {
                                        [key]: <a href={element['documents']} target="_blank"><img src={Images?.DocIcon}
                                                                                                   alt=""
                                                                                                   className="view-icon"/></a>
                                    }
                                    : {[key]: element[key]}
                    ))
                )
            )
            data && setListData(data);
        }

        setPageCount(Math.ceil(taskList.total / taskList.per_page));

    }, [taskList])

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await getList(filter, val.selected + 1)
        setIsLoading(false);
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const applyFilter = async (filterData) => {
        localStorage.setItem("network_eng_task", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await getList(filterData, 1);
        setIsLoading(false);
        filterToggle();
    };

    const headerBtns = () => {
        return (
            <>
                {(role === 27 || role === 9)  && <div className="Pm-btn pm-btn-align">
                    <Link
                        to={`${baseUrl}/task_form`}
                        className="btn btn-primary d-none d-md-inline-block"
                    >
                        {localization.createTask}
                        <img src={Images?.ArrowRight} alt=""></img>
                    </Link>
                </div>
                }
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""></img>
                    {localization.showFilters}
                </Button>
            </>
        )
    }
    return (
        <Layout
            title={localization.w}
            Buttons={headerBtns}
            isLoading={isLoading}
            isGoback={true}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                srNo={taskList?.from}
                onPageChange={onPageChange}
                pageCount={pageCount}
                detailList={taskList}
            />
            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                networkEngFilter={true}
                isRoleId={role}
            />
        </Layout>
    );

};
export default EnggTasksDetails;